export default "__VITE_ASSET__427c55e0__";